export enum OfficeAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    ADD_OFFICE_LIST = "ADD_OFFICE_LIST",
    UPDATE_OFFICE_LIST = "UPDATE_OFFICE_LIST",
    UPDATE_OFFICE_SEARCH_REQ = "UPDATE_OFFICE_SEARCH_REQ",
    SET_UPDATE_OFFICE = "SET_UPDATE_OFFICE",
}